import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ReactiveFormsModule, FormControl } from '@angular/forms';
import { MultiSelectModule } from 'primeng/multiselect';
import { AutoValidateDirective } from '../../directives/auto-validate.directive';
import { FIELD_CONTROL, FIELD_CONFIG } from './field-tokens';

@Component({
  selector: 'app-field-multiselect',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, MultiSelectModule, AutoValidateDirective],
  template: `
    <p-multiselect
      [formControl]="formControl"
      [options]="config.options ? config.options() : []"
      optionLabel="label"
      optionValue="value"
      appendTo="body"
      [placeholder]="config.placeholder || 'Select options'"
      [class]="config.controlClass || 'w-full'"
      [filter]="true"
      appAutoValidate />
  `
})
export class MultiselectFieldComponent {
  readonly config  = inject(FIELD_CONFIG);
  readonly control = inject(FIELD_CONTROL);
  get formControl(): FormControl { return this.control as FormControl; }
}
